export const flattenReferralsData = (data) => {
  return data?.flatMap((user) => {
    if (user?.referrals?.length) {
      return user.referrals?.flatMap((referral, referralIndex) => {
        if (referral?.business_accounts?.length) {
          return referral?.business_accounts?.map((business_account, baIndex) => ({
            row_id: `${user?.user_email}_${referral?.user_email}_${business_account?.business_account_id}`,
            ...user,
            referral,
            business_account,
            userRowSpan:
              referralIndex === 0 && baIndex === 0
                ? user?.referrals?.reduce(
                    (sum, cur) => sum + (cur?.business_accounts?.length || 1),
                    0
                  )
                : 0,
            referralRowSpan: baIndex === 0 ? referral?.business_accounts?.length : 0
          }))
        } else
          return {
            row_id: `${user?.user_email}_${referral?.user_email}`,
            ...user,
            referral,
            business_account: null,
            userRowSpan:
              referralIndex === 0
                ? user?.referrals?.reduce(
                    (sum, cur) => sum + (cur?.business_accounts?.length || 1),
                    0
                  )
                : 0,
            referralRowSpan: 1
          }
      })
    } else
      return {
        ...user,
        row_id: `${user.user_email}`,
        referral: null,
        business_account: null,
        userRowSpan: 1,
        referralRowSpan: 1
      }
  })
}
